import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M5.375 9.75 1 5.375m0 0L5.375 1M1 5.375h5.6c2.94 0 4.41 0 5.533.572a5.25 5.25 0 0 1 2.295 2.295C15 9.365 15 10.835 15 13.775V15"
    }, null, -1)
  ])))
}
export default { render: render }